"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
/* eslint-disable*/
exports.default = {
  "course_zlb": {
    "allCourses": "Tous les cours",
    "className": "Nom du séminaire",
    "continue": "Continuer à étudier",
    "courseChapter": "Chapitre",
    "courseEvaluate": "Évaluation du cours",
    "courseHours": "Heures de cours",
    "courseInfo": "Détail",
    "courseNote": "Note",
    "coursesCategory": "Type de cours",
    "electiveCourses": "Cour facultatif",
    "pages": "Numéro de page",
    "relatedCourses": "Cours concerné",
    "requiredCourses": "Conférence",
    "searchTips": "Veuillez saisir le nom du cours",
    "studentsNum": "Nombre de spectateurs",
    "teachersDesc": "Introduction du conférencier",
    "newCourse": "Dernier cours"
  },
  "footer_zlb": {
    "aboutUs": "Nous connaître",
    "downLoad": "Téléchargement de l'application",
    "qr": "Code QR"
  },
  "global_zlb": {
    "am": "Matinée",
    "night": "Soir",
    "pm": "Après-midi"
  },
  "header_zlb": {
    "accoutPw": "Mot de passe",
    "curDis": "En cours",
    "curUser": "Utilisateur actuel",
    "edit": "Modification",
    "helpCenter": "Centre d'aide",
    "hisDis": "Historique",
    "index": "Page d'accueil",
    "joinStore": "Ajouter aux favoris",
    "logo": require('@/static/images/index_zlb/logo.png'),
    "logoText": require('@/static/images/index_zlb/logo-t.png'),
    "message": "Message",
    "setIndex": "Utiliser comme page d'accueil",
    "userImg": "Photo de profil"
  },
  "index_zlb": {
    "discuss": "Séminaire",
    "find": "Découvrir",
    "textImg": require('@/static/images/index_zlb/text.png'),
    "userCenter": "Moi"
  },
  "info_zlb": {
    "admin": "Administrateur",
    "hasAgenda": "Vous avez déjà participé à ce programme !",
    "noDown": "Aucune annexe à télécharger",
    "pleaseInp": "Veuillez entrer",
    "submit": "Téléchargé réussi !",
    "withinTime": "Mission non commencée",
    "noSubmitWork": "Devoir non soumis"
  },
  "login_zlb": {
    "accountLogin": "Se connecter",
    "accountNotEmpty": "L'identifiant ne peut être vide",
    "bg": require('@/static/images/login_zlb/login_bg.jpg'),
    "bian": require('@/static/images/login_zlb/bianzu.png'),
    "cancel": "Annuler",
    "captchaNotEmpty": "Le code de vérification ne peut être vide",
    "captchaTips": "Code de vérification incorrect",
    "changeEmail": "Modification de l'adresse e-mail",
    "changeEmailSuccess": "Modification de l'adresse e-mail réussie",
    "changeEmailSuccessTips": "Vous avez modifié votre adresse e-mail",
    "Confirm": "Confirmer",
    "currentEmail": "adresse e-mail actuelle",
    "emailCaptcha": "code de vérification de l'adresse e-mail",
    "emailCaptchaEmpty": "Le code de vérification de l'adresse e-mail ne peut être vide",
    "encryEmail": "Adresse e-mail de récupération",
    "error": "Erreur de code de vérification",
    "forget": "Mot de passe oublié",
    "formerEamil": "Adresse e-mail original",
    "incorrectTips": "Erreur de saisie d'identifiant ou de mot de passe",
    "logo": require('@/static/images/login_zlb/logo.png'),
    "newEmail": "Nouvelle adresse e-mail",
    "newEmailBinded": "La nouvelle adresse e-mail est liée à votre compte utilisateur",
    "newEmailEmpty": "La nouvelle adresse e-mail ne peut être vide",
    "newEmailFomat": "Erreur de format de l'adresse e-mail",
    "newEmailSupport": "La nouvelle adresse e-mail ne peut être identique que l'adresse e-mail originale",
    "prevStep": "Étape dernière",
    "nextStep": "Étape suivante",
    "reset": "Réinitialiser",
    "loginNow": "Connectez-vous maintenant",
    "resetSuccess": "Réinitialisé réussi",
    "resetSuccessTips": "Réinitialisé votre mot de passe réussi. Connectez - vous.",
    "msgCaptcha": "Code de vérification par SMS",
    "getCaptcha": "Obtenir le code de vérification",
    "resetPassword": "Réinitialiser le mot de passe",
    "loginFail": "Connexion échouée. Veuillez réessayer!",
    "failTips": "Vérification échouée",
    "inputUserName": "Identifiant",
    "goHome": "Retourner à la page d'accueil",
    "passwordFormat": "Votre mot de pasee doit comporter de 8 à 32 caractères et au moins un chiffre, une lettre majuscule et une ettre minuscule",
    "surePasswordEmpty": "Votre mot de passe de confirmation ne peut être vide",
    "confirmNot": "Les deux saisies de mot de passe ne sont pas identiques",
    "changePasswordSuccess": "Modification de mot de passe réussie",
    "continueLogin": "Connectez - vous à nouveau",
    "orError": "Erreur d'identifiant ou mot de passe",
    "orgEmailEmpty": "L'adresse e-mail originale ne peut être vide",
    "orgEmailFormat": "Erreur de format de l'adresse e-mail originale",
    "orgEmailNot": "Erreur de l'adresse e-mail originale",
    "passWord": "Mot de passe",
    "surePassword": "Confirmez votre mot de passe.",
    "passwordBits": "La longueur du mot de passe ne peut être inférieure à 6 caractères",
    "passwordNotEmpty": "Le mot de passe ne peut être vide",
    "pWord": "Mot de passe",
    "sign": "Se connecter",
    "uName": "Identifiant",
    "userName": "Identifiant",
    "validate": "Code de vérification",
    "verification": "Veuillez finir la vérification suivante",
    "appdownload": "Télécharger l'application mobile",
    "scancode": "Scanner le code QR pour télécharger l'application",
    "poor": "Faible",
    "middle": "Moyen",
    "strong": "Fort"
  },
  "login": {
    "logout": "Déconnexion réussie",
    "resetLoginTips": "Votre mot de passe a été modifié avec succès, veuillez vous connecter à nouveau. Déconnexion automatique dans 3 secondes",
    "sure": "Confirmer",
    "cancel": "Annuler",
    "captchaNotEmpty": "Le code de vérification ne peut être vide",
    "accountNotEmpty": "L'identifiant ne peut être vide",
    "passwordNotEmpty": "Le mot de passe ne peut être vide",
    "inputCaptcha": "Code de vérification",
    "getCaptcha": "Obtenir le code de vérification",
    "inputOrigPassword": "Veuillez saisir le mot de passe original",
    "inputNewPassowrd": "Veuillez saisir le nouveau mot de passe",
    "confimPassword": "Confirmez votre mot de passe.",
    "changePassword": "Mise à jour du mot de passe",
    "nextStep": "Étape suivante",
    "resetPassword": "Réinitialiser le mot de passe",
    "resetDone": "Mot de pass réinitialisé réussi",
    "msgCaptcha": "code de vérification de l'adresse e-mail"
  },
  "look_zlb": {
    "aboutLecturer": "Cours concerné",
    "benginLearn": "Commencer à apprendre",
    "chapter": "Chapitre",
    "delete": "Supprimer",
    "details": "Détail",
    "download": "Télécharger",
    "dynamic": "Actualités",
    "evaluation": "Évaluation",
    "hotDyc": "Actualités chaudes",
    "lecture": "Cours ouvert",
    "lecturer": "Conférencier",
    "lectureTest": "Type de cours",
    "look": "Découvrir",
    "lookAll": "Tout affichierr",
    "note": "Note",
    "score": "Noter"
  },
  "myMessage_zlb": {
    "passwordError": "Erreur de saisie de mot de passe original",
    "aboutUs": "Nous connaître",
    "allcourse": "Tous les cours",
    "atypism": "Deux mots de passe ne sont pas identiques",
    "birth": "Date de naissance",
    "cancel": "Annuler",
    "carryOut": "Terminer",
    "changePassword": "Mise à jour du mot de passe",
    "chineseName": "Nom chinois",
    "chineseNamePlaceholder": "Veuillez saisir le nom chinois",
    "code": "Code de vérification",
    "codeError": "Erreur de code de vérification",
    "comment": "Commentaires",
    "complete": "Terminer",
    "completeUserInfo": "Veuillez compléter vos informations personnelles",
    "confirm": "Confirmez votre mot de passe",
    "continueStudy": "Continuer à étudier",
    "country": "Pays",
    "countryName": "Nom",
    "countryNamePlaceholder": "Veuillez saisir votre nom du pays",
    "countryPlaceholder": "Veuillez choisir un pays",
    "courseLearned": "Cours suivis",
    "delete": "Supprimer",
    "documentType": "Type de pièce d'identité",
    "downloaded": "Téléchargement réussi",
    "downloading": "Téléchargement en cours",
    "eduLevel": "Niveau d'éducation",
    "eduLevelPlaceholder": "Veuillez choisir votre niveau d'éducation",
    "email": "Adresse e-mail",
    "emailCode": "code de vérification de l'adresse e-mail",
    "gender": "Sexe",
    "genderPlaceholder": "Veuillez choisir le sexe",
    "getCode": "Obtenir le code de vérification par e-mail",
    "hasSent": "Envoyé",
    "helpCenter": "Centre d'aide",
    "hour": "Heure",
    "improveInformation": "Veuillez compléter vos informations personnelles",
    "joinClasses": "Nombre de cours participés",
    "joinDis": "Nombre de séminaires participés",
    "learned": "Cours étudié",
    "learning": "Cours inachevé",
    "lecture": "Cours",
    "mailbox": "Adresse e-mail",
    "mailboxValidate": "Vérification par e-mail échouée",
    "man": "Homme",
    "management": "Gestion",
    "minutes": "X heures x minutes",
    "modify": "Modification",
    "modifyEmail": "Modification de l'adresse e-mail",
    "my": "Moi-même",
    "myCertificate": "Mes certificats",
    "mycourse": "Mes cours",
    "myDownload": "Mes téléchargements",
    "myLecture": "Mes cours",
    "myNotes": "Mes messages",
    "newMail": "Nouvelle adresse e-mail",
    "newPassword": "Nouveau mot de passe",
    "nextStep": "Étape suivante",
    "orError": "Erreur d'identifiant ou mot de passe",
    "origin": "De",
    "originalPassword": "Mot de passe original",
    "password": "Mot de passe",
    "phone": "Numéro de téléphone",
    "pleChoose": "Veuillez choisir votre date de naissance",
    "post": "Poste",
    "postPlaceholder": "Veuillez entrer votre poste",
    "religion": "Religion",
    "religionPlaceholder": "Veuillez choisir votre religion",
    "retrievePassword": "Retrouver votre mot de passe",
    "setUp": "Paramètre",
    "signOut": "Quitter",
    "something": "Prêt à dire quelque chose",
    "submit": "Soumettre",
    "sureDelte": "Vous êtes sûr de supprimer ce data ?",
    "teacher": "Conférencier",
    "learnYet": "Cours non commencé",
    "uName": "Identifiant",
    "uNamePlaceholder": "Identifiant",
    "userCenter": "Informations personnelles",
    "username": "Identifiant",
    "validateMsg": "Vérification échouée",
    "woman": "Femme",
    "learnTo": "Étudier jusqu'à",
    "myRecord": "Mon dossier",
    "plePhone": "Veuillez entrer le numéro de téléphone"
  },
  "notice_zlb": {
    "delete": "Supprimer",
    "home": "Page d'accueil",
    "lettre": "Message privé",
    "lettreEmpty": "Le message privé ne peut être vide",
    "messageDetail": "Détail de message",
    "myMessage": "Mes messages",
    "notice": "Avis",
    "nowBavarder": "Prêt à parler",
    "send": "Envoyer"
  },
  "play_zlb": {
    "networkTip": "Notification du réseau",
    "streamHighTip": "La connexion réseau est stable. Nous avons changé de mode HD pour vous.",
    "streamHighType": "HD",
    "streamNormTip": "La connexion réseau est instable. Nous avons changé de mode SD pour vous.",
    "streamNormType": "SD",
    "liveTimeDes": "Heure du live",
    "livePlayWait": "Live n'est pas commencé",
    "livePlayEnd": "Live est terminé"
  },
  "questionnaire_zlb": {
    "handed": "Soumettre",
    "saveFailed": "Enregistrement échoué",
    "examList": "Liste des sujets"
  },
  "research_zlb": {
    "afternoon": "Après-midi",
    "all": "Tout",
    "allCalendar": "Ensemble de l'ordre du jour",
    "alumniBook": "Membre",
    "broadcast": "X est en live",
    "carriedout": "En cours",
    "certificate": "Certificat",
    "comment": "Commentaires",
    "comments": "Tous les X commentaires",
    "courses": "Références",
    "curDis": "En cours",
    "default": "Non commencé",
    "delete": "Supprimer",
    "detail": "Détail",
    "discuss": "Forum",
    "end": "Déjà terminé",
    "endAssess": "Évaluation terminée",
    "enterAssess": "Commencer l'évaluation",
    "assessButton": "Évaluation du séminaire",
    "evaluation": "Évaluation",
    "fileAcept": "Erreur de format de fichier, veuillez la télécharger à nouveau ",
    "fileSize10": "Le fichier sélectionné dépasse 10M, veuillez la télécharger à nouveau",
    "hisDis": "Historique",
    "lecture": "Références",
    "live": "En direct",
    "livebroadcast": "Live",
    "minutes": "Il y a x minutes.",
    "month": "Mois",
    "morning": "Matinée",
    "noDiscussion": "Pas de séminaire",
    "noSchedule": "Pas de programme",
    "notice": "Avis",
    "notification": "Avis non lu",
    "offline": "Cours présentiel",
    "onging": "En cours",
    "online": "En ligne",
    "operation": "Devoir",
    "over": "Déjà terminé",
    "participated": "Déjà participé",
    "notParticipate": "Non participé",
    "failedCourse": "Non passé",
    "passedCourse": "Passé",
    "preparation": "Préparation des missions (clôture)",
    "preparations": "Préparation des missions",
    "preschoolLecture": "Conférence d'échauffement",
    "questionnaire": "Questionnaire",
    "questionType ": "Type de question (Question à choix multiple à réponse unique, question à choix multiple à réponses multiples, vrai ou faux, question à réponse courte)",
    "readySay": "Prêt à dire quelque chose",
    "replies": "Vous avez x nouvelle(s) réponse(s)",
    "save": "Enregistrer",
    "schedule": "Agenda",
    "searchC": "Rechercher le contenu qui vous intéresse",
    "seeAssess": "Consulter l'évaluation",
    "submit": "Soumettre",
    "submitHomewor": "Annuler",
    "task": "Tâche",
    "taskToday": "La tâche d'aujourd'hui",
    "video": "Vidéo",
    "week": "Semaine",
    "yourcomment": "Écrivez vos commentaires",
    "legend": "Légende",
    "sunday": "Dimanche",
    "monday": "Lundi",
    "tuesday": "Mardi",
    "wednesday": "Mercredi",
    "thursday": "Jeudi",
    "friday": "Vendredi",
    "saturday": "Samedi",
    "consult": "Nombre de références",
    "schedules": "Nombre de programmes",
    "calendar": "Calendrier",
    "waitAssesment": "Questionnaire à soumettre",
    "year": "Année",
    "day": "Jour",
    "preview": "Aperçu",
    "resource": "Télécharger"
  },
  "retrieve_zlb": {
    "emailEmpty": "Adresse e-mail ne peut être vide.",
    "emailVerif": "Vérification par e-mail"
  },
  "task_zlb": {
    "downF": "Télécharger l'annexe",
    "repeatUp": "Télécharger à nouveau",
    "ruY": "Si une annexe est téléchargée sur APP, elle sera couverte si vous en téléchargez une autre sur PC.",
    "submitC": "Veuillez saisir le contenu que vous souhaitez soumettre",
    "uploadF": "Télécharger l'annexe"
  },
  "upload_zlb": {
    "clickHere": "Cliquez ici",
    "limit": "Les formats acceptés sont PNG et JPG, et chaque pièce ne doit pas dépasser la taille de ",
    "preview": "Aperçu après téléchargement d'images",
    "upload": "Télécharger"
  },
  "index": {
    "setAsHomePage": "Utiliser comme page d'accueil",
    "addCollection": "Ajouter aux favoris",
    "telephone": "Ligne téléphonique",
    "Help": "Centre d'aide",
    "SystemMessage": "Avis du système",
    "message": "Message privé",
    "emptyMessage": "Effacer",
    "checkAllMessage": "Tout affichierr",
    "noMessage": "Pas de données",
    "fullScreen": "Mode plein écran",
    "ExitSystem": "Quitter le système",
    "back": "Retourner",
    "top": "Haut de page",
    "backToTop": "Retourner en haut de la page",
    "homePage": "Page d'accueil",
    "favoriteTips": "En raison des limites du navigateur 360, appuyez sur Ctrl+D pour ajouter aux Favoris manuellement",
    "autoSetHomeTips": "La paramètre automatique de la page d'accueil est temporairement limité pour votre navigateur, veuillez la configurer avec le menu du navigateur manuellement !",
    "currentUser": "Utilisateur actuel",
    "userHead": "Photo de profil",
    "accountPassword": "Mot de passe",
    "change": "Modification",
    "head": "Photo de profil",
    "continueStudy": "Continuer à étudier",
    "startStudy": "Commencer à apprendre"
  },
  "course": {
    "count": "Au total",
    "item": "Article",
    "up": "Page précédente",
    "next": "Page suivante",
    "items": "Articles/Page",
    "go": "Sauter jusqu'à",
    "page": "Numéro de page",
    "man": "Utilisateur",
    "score": "Points",
    "courseYear": "Année",
    "courseTeachers": "Conférencier",
    "noDesc": "Pas d'introduction",
    "teachersDesc": "Introduction du conférencier",
    "checkLog": "Consulter les enregistrements",
    "startStudy": "Commencer à apprendre",
    "JoinLearning": "Participer au cours",
    "isEvaluate": "Évalué",
    "deleteNoteButton": "Supprimer",
    "closeButton": "Fermé",
    "noteSource": "De"
  },
  "onlineclass": {
    "myScore": "Ma note",
    "comments": "Observations",
    "iknow": "Je le sais",
    "detail": "Détail",
    "inforCertificate": "Certificat",
    "wantTalk": "Je voudrais faire un commentaire",
    "inputTalkContent": "Veuillez saisir les notes",
    "publish": "Publier",
    "undo": "Annuler",
    "reply": "Répondre",
    "delete": "Supprimer",
    "Learned": "Cours suivis",
    "isDelete": "Vous êtes sûr de le supprimer?",
    "submitTime": "Date de soumission",
    "to": "A",
    "download": "Télécharger"
  },
  "usercenter": {
    "htllo": "Bonjour",
    "welcomeMessage": "Bonne journée",
    "searchTips": "Entrez le nom de la conférence que vous recherchez",
    "myCertificate": "Mes certificats",
    "startQuestionnaire": "Commencer à répondre",
    "empty": "Rien",
    "confirmDelete": "Suppression confirmée",
    "confirmDeleteTips": "Vous êtes sûr de le supprimer?",
    "delete": "Supprimer",
    "integralscore": "Student points"
  },
  "play": {
    "endStudy": "Terminer les études",
    "tips": "Conseils",
    "playTips": "Conseils: Veuillez cliquer sur le bouton «Terminer les études» en haut à droite pour quitter. Si vous fermez directement le navigateur, votre temps d'apprentissage ne peut être enregistré correctement.",
    "notShowAgain": "Ne plus affichierr ce message",
    "gotIt": "Je le sais",
    "chapter": "Chapitre",
    "language": "Langues",
    "chapterText1": "No.",
    "chapterText2": "Chapitre",
    "note": "Note",
    "noteBlockTitle": "Note",
    "evaluate": "Évaluation",
    "evaluateStar": "Étoile",
    "saveEvaluate": "Soumettre",
    "notePlaceholder": "Veuillez écrire les notes",
    "closeTips": "Les modifications que vous avez faites ne peuvent être enregistrées",
    "closeButton": "Quitter",
    "autoStop": "Arrêt automatique de diffusion",
    "autoStopTips": "Vous n'avez pas effectué d'opération pendant longtemps, le système arrête automatiquement la diffusion de vidéo",
    "confirmOut": "Vous êtes sûr de quitter la diffusion ?",
    "closeOrNot": "Voulez-vous fermer la fenêtre actuelle",
    "noCoursePlay": "Aucune ressource disponible dans le cours actuelle",
    "attention": "Attention!"
  },
  "assessment_zlb": {
    "score": "Points",
    "evalSuccess": "Évalué avec succès"
  },
  "undefined": {
    "undefined": "Isi catatan tidak boleh kosong"
  }
};